"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollDataEventsType = exports.StatusUpdateErrorReasons = exports.Groupings = void 0;
var Groupings;
(function (Groupings) {
    Groupings["grouping"] = "grouping";
    Groupings["creditor_id"] = "creditor_id";
    Groupings["payout_date"] = "payout_date";
})(Groupings = exports.Groupings || (exports.Groupings = {}));
var StatusUpdateErrorReasons;
(function (StatusUpdateErrorReasons) {
    StatusUpdateErrorReasons["INVALID_CURRENT_STATUS"] = "INVALID_CURRENT_STATUS";
    StatusUpdateErrorReasons["INVALID_NEXT_STATUS"] = "INVALID_NEXT_STATUS";
    StatusUpdateErrorReasons["ERROR_ON_DISPATCH_ACTION"] = "ERROR_ON_DISPATCH_ACTION";
})(StatusUpdateErrorReasons = exports.StatusUpdateErrorReasons || (exports.StatusUpdateErrorReasons = {}));
var PayrollDataEventsType;
(function (PayrollDataEventsType) {
    PayrollDataEventsType["PAYROLL_DATA"] = "payroll_data_event";
    PayrollDataEventsType["OUTBOUND_WEBHOOK_ACTION"] = "outbound_webhook_action_event";
})(PayrollDataEventsType = exports.PayrollDataEventsType || (exports.PayrollDataEventsType = {}));
